import { reactive, readonly } from 'vue'
import emitter from '@/emitter'

const state = reactive({
  isAuthenticated: false,
  isReady: false,
  isStarted: false,
  isEnded: false,
  currentSound: 'clairiere',
  // isMuted: true,
  user: {
    progress: 0,
    isOnKeypoint: false,
    currentRoom: 0,
    currentKp: null
  },
});

const auth = function () {
  state.isAuthenticated = true;
}

const load = function () {
  state.isReady = true;
}

const start = function () {
  state.isStarted = true;
}

const ended = function () {
  state.isEnded = true;
}

const sound = function (value) {
  state.currentSound = value;
}

const restartroom = function (id) {
  state.isEnded = false;
  state.user.progress = id === 0 ? 0 : 3;
  state.user.currentKp = null;
  state.user.isOnKeypoint = false
  emitter.emit('RESTART', id)
}

// const toggleSound = function (value) {
//   if (typeof value !== 'undefined') {
//     state.isMuted = value
//   } else {
//     state.isMuted = !state.isMuted
//   }
//   console.log('EMOT')
//   // emitter.emit('SOUND', state.isMuted)
// }

const openkp = function (id, hasBeenVisited) {
  state.user.isOnKeypoint = true
  if (!hasBeenVisited) {
    state.user.progress ++
  }
  state.user.currentKp = id

  // console.log('STATE', state.user.progress)
}

const closekp = function () {
  state.user.isOnKeypoint = false
}

export default {
  state: readonly(state),
  auth,
  load,
  openkp,
  closekp,
  start,
  ended,
  sound,
  restartroom
};